<template>
  <div>

    <div v-if="loading" style="padding: 4rem;">
      <InlineSpinner />
    </div>

    <div v-else class="agent-card-container">
      <div class="broker-container">
        <div class="brokerage-name" :style="{ backgroundColor: tenantProfile.brandColor || '#444' }">
          {{ tenantProfile.name || '&nbsp;' }}
          <div v-if="showCloseButton" style="cursor: pointer; float: right;" @click="$store.commit('closeAgentCardDialog')"><v-icon color="white" size="medium">close</v-icon></div>
        </div>
        <div class="broker-photo"><img :src="brokerPhoto" class="user-avatar" /></div>
        <div class="broker-info">
          <div class="broker-name">{{ user.firstName }} {{ user.lastName }}</div>
          <div v-if="user.title">Title: {{ user.title }}</div>
          <div v-if="user.breNumber">DRE License Number: {{ user.breNumber }}</div>
          <div v-if="user.phone">Cell Phone Number: {{ user.phone }}</div>
          <div v-if="user.officePhone">Office Phone Number: {{ user.officePhone }}</div>
          <!--
          <div v-if="user.fax">Fax Phone Number {{ user.fax }}</div>
          -->
          <div>Email: <a :href="'mailto:' + user.email">{{ user.email }}</a></div>
          <div class="broker-logo"><img :src="tenantLogoUrl(tenantProfile)" /></div>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
  import VueMarkdown from 'vue-markdown'
  import InlineSpinner from './../elements/InlineSpinner.vue'
  import { tenantLogoUrl } from '../../utils/PfxUtils.js'

  export default {
    name: 'AgentCard',
    components: {
      VueMarkdown,
      InlineSpinner
    },
    props: {
      userId: {
        type: String,
        required: false,
        default: () => null
      },
      userProfile: {
        type: Object,
        required: false,
        default: () => {}
      },
      tenantSubdomain: {
        type: String,
        required: true
      },
      showCloseButton: {
        type: Boolean,
        required: false,
        default: false
      }
    },
    data() {
      return {
        loading: 0,
        user: {},
        tenantProfile: {}
      }
    },
    computed: {
      brokerPhoto() {
        return this.user.photoUrl || this.user.avatarUrl || require('../../assets/placeholder-user.png')
      }
    },
    watch: {
      userId() {
        console.log('AgentCard userId changed', this.userId)
        this.loadProfile()
      },
      userProfile() {
        console.log('AgentCard userProfile changed', this.userProfile)
        this.loadProfile()
      }
    },
    created() {
      this.loadProfile()
    },
    methods: {
      tenantLogoUrl,

      loadProfile() {
        if (this.userId) {
          this.loading++
          this.$PfxBackendApi.getUser(this.userId).then(res => {
            if (res.data.id) {
              console.info('AgentCard: getUser res', res) // res.data = { id, email, firstName, lastName, phone, photoUrl }
              this.user = res.data
            }
          }).catch(err => {
            console.error('AgentCard: getUser error', err)
          }).then(() => this.loading--)
        } else if (this.userProfile.id) {
          this.user = this.userProfile
        } else if (this.userProfile.userId) {
          this.user = this.userProfile
        } else {
          this.user = {}
          this.tenantProfile = {}
          return
        }

        this.tenantProfile = {}
        this.loading++
        this.$PfxBackendApi.getTenantPublic(this.tenantSubdomain).then(res => {
          console.info('AgentCard: getTenantPublic res', res) // res.data = { logoUrl, extLogoUrl, name }
          this.tenantProfile = res.data || {}
        }).catch(err => {
          console.error('AgentCard: getTenantPublic error', err)
        }).then(() => this.loading--)
      }
    }
  }
</script>

<style lang="scss" scoped>
  @import '../../pfx.scss';

  .agent-card-container {
    border-radius: 8px 8px;
    background-color: #fff;
    box-shadow: 0 2px 4px 0 #ccc;
    display: inline-block;
    min-width: 350px;
    font-size: 12px;
    text-align: left;

    .broker-container {

      .brokerage-name {
        background-color: #444;
        color: white;
        font-size: 14px;
        font-weight: 600;
        padding: 4px 6px 4px 14px;
        border-radius: 8px 8px 0 0;
      }

      .broker-photo {
        float: left;
        padding: 18px;
        img {
          width: 64px;
        }
      }

      .broker-info {
        margin-left: 90px;
        padding: 1em;
        position: relative;

        .broker-name {
          font-family: 'Encode Sans', sans-serif;
          font-size: 16px;
        }

        .broker-logo {
          position: absolute;
          top: 12px;
          right: 12px;
          img {
            width: 40px;
          }
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/elements/AgentCard.vue